import {createContext} from 'react';

/**
 * When Icon is rendered inside IconSet's explainer blocks grid, this is set to 'valueProp'
 * so Icon uses Value Prop styling (48px icon, Figma typography). Otherwise icons use default styling.
 * @type {React.Context<'icons'|'valueProp'>}
 */
export const IconSetSectionContext = createContext('icons');
